import { Box, Typography } from "@mui/material";
import React from "react";
import "./PublicPages.css";

const YieldTermsPublic = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f5f5f5",
        padding: { xs: "20px", sm: "40px", md: "60px" },
      }}
    >
      <Box
        sx={{
          maxWidth: "900px",
          margin: "0 auto",
          bgcolor: "#fff",
          padding: { xs: "20px", sm: "40px" },
          borderRadius: "8px",
          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: "24px", sm: "32px" },
            fontWeight: "600",
            marginBottom: "30px",
            color: "#0C2C50",
          }}
        >
          FIDDUX Yield Products - Terms and Conditions
        </Typography>

        <Box
          sx={{
            marginTop: "20px",
            paddingBottom: "20px",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Typography variant="body2" sx={{ color: "#666", marginBottom: "8px" }}>
            <strong>Last Updated:</strong> December 29, 2025
          </Typography>
          <Box sx={{ marginTop: "16px" }}>
            <a
              href="/termsAndCondition"
              style={{ color: "#0C2C50", textDecoration: "none", marginRight: "20px" }}
            >
              General Terms and Conditions
            </a>
            <a
              href="/privacyPolicy"
              style={{ color: "#0C2C50", textDecoration: "none" }}
            >
              Privacy Policy
            </a>
          </Box>
        </Box>

        <Box
          className="public-page-content"
          sx={{
            "& p": {
              marginBottom: "16px",
              lineHeight: "1.6",
              color: "#333",
            },
            "& h2": {
              fontSize: "24px",
              fontWeight: "600",
              marginTop: "30px",
              marginBottom: "16px",
              color: "#0C2C50",
            },
            "& h3": {
              fontSize: "18px",
              fontWeight: "600",
              marginTop: "24px",
              marginBottom: "12px",
              color: "#0C2C50",
            },
            "& ul, & ol": {
              marginBottom: "16px",
              paddingLeft: "24px",
            },
            "& li": {
              marginBottom: "8px",
            },
          }}
        >
          <Box sx={{ marginTop: "30px" }}>
            <Typography variant="h2" component="h2">
              1. Yield Product Participation Terms
            </Typography>

            <Typography variant="h3" component="h3">
              Governing Law and Jurisdiction
            </Typography>
            <Typography component="p">
              This Yield Product Participation Agreement ("Agreement") is governed by the laws of the Republic of Estonia. 
              Any disputes shall be subject to the exclusive jurisdiction of the courts of Tallinn, Estonia.
            </Typography>

            <Typography variant="h3" component="h3">
              Participation Terms
            </Typography>
            <Typography component="p">By activating this Yield Product, you acknowledge and agree that:</Typography>

            <Typography variant="h3" component="h3">
              Participation Commencement
            </Typography>
            <Typography component="p">
              Your account balance will begin participating in this Yield Product, managed in partnership with qualified 
              third-party providers, starting the day after activation. Participation is calculated daily based on your 
              net balance at the fund's closing time.
            </Typography>

            <Typography variant="h3" component="h3">
              Yield Calculation and Rates
            </Typography>
            <ul>
              <li>Yield is calculated separately from your regular fund performance through specialized third-party strategies.</li>
              <li>Monthly yield rates are determined by the fund administrator in collaboration with our partners and may vary each month. Returns are approximate and depend on market conditions.</li>
              <li>Yield is calculated proportionally based on the number of days you participate each month. Yield is not compounded and is not cumulative.</li>
              <li>Returns may vary and are not guaranteed. Past performance does not indicate future results.</li>
            </ul>

            <Typography variant="h3" component="h3">
              Administrator Discretion
            </Typography>
            <Typography component="p">
              All yield calculations, rate determinations, and payment decisions are final and binding. The administrator 
              reserves the right to adjust calculations or terms in consultation with our partners.
            </Typography>

            <Typography variant="h3" component="h3">
              Payment Terms
            </Typography>
            <ul>
              <li>Yield earnings are accumulated throughout the product period.</li>
              <li>Payment is made in a single transaction at the end of the product period, after administrator and partner verification.</li>
              <li>You will not receive monthly payments or previews of accumulated yield during the product period.</li>
            </ul>

            <Typography variant="h3" component="h3">
              Deactivation and Reactivation
            </Typography>
            <ul>
              <li>You may deactivate participation at any time, with effect from the following day.</li>
              <li>Deactivating and reactivating on the same day will result in zero yield for that day.</li>
              <li>Frequent toggling (more than 3 times per month) may result in restricted access at the administrator's discretion.</li>
            </ul>

            <Typography variant="h3" component="h3">
              Product Transition
            </Typography>
            <Typography component="p">
              Future products may involve different third-party partners and require acceptance of then-current terms.
            </Typography>

            <Typography variant="h3" component="h3">
              Limitation of Liability
            </Typography>
            <Typography component="p">
              FIDDUX and its third-party partners shall not be liable for any losses, damages, or claims arising from 
              yield participation, except as required by Estonian law.
            </Typography>

            <Typography variant="h3" component="h3">
              Acknowledgment
            </Typography>
            <Typography component="p">
              You confirm that you have read, understood, and agree to all terms and conditions herein.
            </Typography>
          </Box>

          <Box
            sx={{
              margin: "40px 0",
              padding: "16px",
              backgroundColor: "#fff3cd",
              border: "1px solid #ffc107",
              borderRadius: "4px",
            }}
          >
            <Typography variant="h2" component="h2" sx={{ marginTop: "0" }}>
              2. Yield Product Deactivation Terms
            </Typography>
            <Typography component="p" sx={{ fontWeight: "600", marginBottom: "8px" }}>
              ⚠️ IMPORTANT NOTICE
            </Typography>
            <Typography component="p">
              Deactivating your participation may invalidate your eligibility for yield accumulation until the end of 
              the current month. If you deactivate during an active month, you may not be eligible to reactivate and 
              earn yield for the remainder of that month. Please consider this carefully before proceeding.
            </Typography>

            <Typography variant="h3" component="h3">
              Governing Law and Jurisdiction
            </Typography>
            <Typography component="p">
              This Yield Product Deactivation Confirmation ("Confirmation") is governed by the laws of the Republic of Estonia. 
              Any disputes shall be subject to the exclusive jurisdiction of the courts of Tallinn, Estonia.
            </Typography>

            <Typography variant="h3" component="h3">
              Deactivation Terms
            </Typography>
            <Typography component="p">By deactivating this Yield Product, you acknowledge and agree that:</Typography>

            <Typography variant="h3" component="h3">
              Deactivation Effect
            </Typography>
            <ul>
              <li>Your account balance will stop participating in this Yield Product, managed with our third-party partners, starting the day after deactivation.</li>
              <li>Any yield accumulated up to the deactivation date will be preserved and included in your final payment when the product period ends, subject to verification.</li>
            </ul>

            <Typography variant="h3" component="h3">
              Monthly Eligibility Impact
            </Typography>
            <Typography component="p">
              If you deactivate during an active month, you may not be eligible to reactivate and earn yield for the 
              remainder of that calendar month. Eligibility for yield accumulation will resume in the following month 
              if you choose to reactivate.
            </Typography>

            <Typography variant="h3" component="h3">
              Accumulated Yield
            </Typography>
            <ul>
              <li>Yield earned during your participation period will remain in your account and be processed at the end of the product period.</li>
              <li>Final yield payment amounts are subject to administrator and partner verification. The administrator's determination is final and binding.</li>
            </ul>

            <Typography variant="h3" component="h3">
              Future Participation
            </Typography>
            <ul>
              <li>Future Yield Products may involve different third-party partners and will require acceptance of then-current terms.</li>
              <li>If you reactivate in a future month, you will need to accept the then-current terms and conditions.</li>
            </ul>

            <Typography variant="h3" component="h3">
              Limitation of Liability
            </Typography>
            <Typography component="p">
              FIDDUX and its third-party partners shall not be liable for any losses arising from deactivation or yield 
              processing, except as required by Estonian law.
            </Typography>

            <Typography variant="h3" component="h3">
              Acknowledgment
            </Typography>
            <ul>
              <li>You understand that deactivating will stop future yield accumulation from the following day.</li>
              <li>You acknowledge that deactivating during an active month may invalidate your eligibility for yield accumulation for the remainder of that month.</li>
              <li>You confirm that administrator decisions regarding yield payments are final and binding.</li>
            </ul>
          </Box>

          <Box sx={{ marginTop: "30px" }}>
            <Typography variant="h2" component="h2">
              3. General Provisions
            </Typography>

            <Typography variant="h3" component="h3">
              Risk Disclosure
            </Typography>
            <Typography component="p">
              Participation in Yield Products involves risk. While we work with qualified third-party partners and employ 
              professional investment strategies, yield returns are not guaranteed. Market conditions, partner performance, 
              and other factors may affect the actual returns you receive. Past performance does not indicate future results.
            </Typography>

            <Typography variant="h3" component="h3">
              Administrator Authority
            </Typography>
            <Typography component="p">
              The fund administrator reserves the right to make final decisions regarding yield calculations, rate determinations, 
              payment processing, and eligibility for participation. All decisions made by the administrator are final and binding.
            </Typography>

            <Typography variant="h3" component="h3">
              Modifications to Terms
            </Typography>
            <Typography component="p">
              FIDDUX reserves the right to modify these terms and conditions at any time. Material changes will be communicated 
              to participants, and continued participation after such changes constitutes acceptance of the modified terms.
            </Typography>

            <Typography variant="h3" component="h3">
              Contact Information
            </Typography>
            <Typography component="p">
              If you have any questions about these Yield Product terms and conditions, please contact us at:
            </Typography>
            <Typography component="p">
              <strong>Email:</strong> <a href="mailto:order@fiddux.com" style={{ color: "#0C2C50" }}>order@fiddux.com</a><br />
              <strong>Address:</strong> Joe 2, Harjumaa, 10151, Tallinn, Estonia
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            marginTop: "40px",
            paddingTop: "20px",
            borderTop: "1px solid #e0e0e0",
            textAlign: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: "#666" }}>
            Last updated: December 29, 2025
          </Typography>
          <Typography variant="body2" sx={{ color: "#666", marginTop: "8px" }}>
            For questions, contact:{" "}
            <a
              href="mailto:order@fiddux.com"
              style={{ color: "#0C2C50", textDecoration: "none" }}
            >
              order@fiddux.com
            </a>
          </Typography>
          <Typography variant="body2" sx={{ color: "#666", marginTop: "10px" }}>
            <a
              href="/termsAndCondition"
              style={{ color: "#0C2C50", textDecoration: "none", marginRight: "10px" }}
            >
              General Terms and Conditions
            </a>
            {" | "}
            <a
              href="/privacyPolicy"
              style={{ color: "#0C2C50", textDecoration: "none" }}
            >
              Privacy Policy
            </a>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default YieldTermsPublic;

